import type {
  ProjectPhase,
} from '@nightshift/ui-types';

const PHASE_NAME: Record<ProjectPhase, string> = {
  preproduction: 'Preproduction',
  production: 'Production',
  alpha: 'Alpha',
  beta: 'Beta',
  release: 'Release',
  live: 'Live',
  continuous: 'Continuous',
};

export function phaseName(phase: ProjectPhase): string {
  return PHASE_NAME[phase];
}
